import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import Header from './components/Header/Header';
import Card from './components/Card/Card';
import Writers from './components/Writers/Writers';

function App() {

  return (
      <div>
        <Header></Header> <br />
        <Card> </Card>
      </div>
  );
}

export default App;
